import React, { useState } from 'react';
import { FaEnvelope, FaLock, FaEye, FaEyeSlash, FaSignInAlt, FaSpinner, FaUserShield } from 'react-icons/fa';
import { useAdminAuth } from '../../context/AdminAuthContext';
import { useNavigate, Link } from 'react-router-dom';

const AdminLoginPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const { adminLogin } = useAdminAuth();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  const [formData, setFormData1] = useState({
    email: '',
    password: ''
  });

  const [emailValid, setEmailValid] = useState(true);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleInputChange1 = (e) => {
    const { name, value } = e.target;
    setFormData1(prevState => ({
      ...prevState,
      [name]: value
    }));

    if (name === 'email') {
      setEmailValid(validateEmail(value));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateEmail(formData.email)) {
      alert('يرجى إدخال بريد إلكتروني صحيح!');
      return;
    }

    setLoading(true);

    const result = await adminLogin(formData.email, formData.password);
    
    setLoading(false);

    if (result.success) {
      navigate('/admin-23nafs-33/dashboard');
    } else {
      alert(`فشل تسجيل الدخول: ${result.error}`);
    }
  };

  return (
    <div className="min-h-screen grid-pattern flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 relative overflow-hidden" dir="rtl">
      <div className="absolute top-20 left-10 w-72 h-72 bg-[#1a365d] opacity-5 rounded-full blur-3xl float-animation"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#2d3748] opacity-5 rounded-full blur-3xl float-animation" style={{ animationDelay: '2s' }}></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#1a365d] opacity-5 rounded-full blur-3xl"></div>

      <div className="relative w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-20 h-20 mx-auto mb-4 bg-gradient-to-br from-[#1a365d] to-[#2d3748] rounded-2xl flex items-center justify-center shadow-lg">
            <FaUserShield className="text-white text-2xl" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900">نظام الإدارة</h1>
          <p className="mt-2 text-gray-600">تسجيل الدخول لوحة تحكم الإدارة</p>
        </div>

       \
        <div className="card-subtle rounded-2xl shadow-xl p-8">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                البريد الإلكتروني
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 right-0 pr-4 flex items-center pointer-events-none">
                  <FaEnvelope className="text-gray-400" />
                </div>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleInputChange1}
                  className={`input-subtle w-full pr-12 pl-4 py-3.5 rounded-xl text-base ${
                    !emailValid && formData.email ? 'border-red-500' : ''
                  }`}
                  placeholder="admin@example.com"
                />
              </div>
              {!emailValid && formData.email && (
                <p className="mt-1 text-xs text-red-500">
                  يرجى إدخال بريد إلكتروني صحيح
                </p>
              )}
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-semibold text-gray-700 mb-2">
                كلمة السر
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 right-0 pr-4 flex items-center pointer-events-none">
                  <FaLock className="text-gray-400" />
                </div>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  required
                  value={formData.password}
                  onChange={handleInputChange1}
                  className="input-subtle w-full pr-12 pl-12 py-3.5 rounded-xl text-base"
                  placeholder="••••••••"
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="absolute inset-y-0 left-0 pl-4 flex items-center text-gray-400 hover:text-gray-600 transition-colors"
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-[#1a365d] to-[#2d3748] hover:from-[#2d3748] hover:to-[#1a365d] text-white font-semibold py-3.5 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                <>
                  <FaSpinner className="ml-2 inline animate-spin" />
                  جاري تسجيل الدخول...
                </>
              ) : (
                <>
                  <FaSignInAlt className="ml-2 inline" />
                  تسجيل الدخول كمسؤول
                </>
              )}
            </button>
          </form>
        </div>

        <div className="mt-6 space-y-3 text-center">
          <p className="text-sm text-gray-600">
            <Link to="/login" className="font-semibold text-[#1a365d] hover:text-[#2d3748] transition-colors mr-1">
              تسجيل الدخول كطالب
            </Link>
          </p>
          <p className="text-sm text-gray-600">
            <Link to="/" className="font-semibold text-[#1a365d] hover:text-[#2d3748] transition-colors mr-1">
              العودة للرئيسية
            </Link>
          </p>
        </div>
      </div>

      <style jsx>{`
        .grid-pattern {
          background-image:
            linear-gradient(rgba(26, 54, 93, 0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(26, 54, 93, 0.03) 1px, transparent 1px);
          background-size: 30px 30px;
        }

        .input-subtle {
          background: rgba(255, 255, 255, 0.6);
          border: 1.5px solid rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
        }

        .input-subtle:focus {
          outline: none;
          border-color: #1a365d;
          background: rgba(255, 255, 255, 0.9);
          box-shadow: 0 0 0 3px rgba(26, 54, 93, 0.1);
        }

        .card-subtle {
          background: rgba(255, 255, 255, 0.8);
          border: 1px solid rgba(0, 0, 0, 0.08);
          backdrop-filter: blur(20px);
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }

        .float-animation {
          animation: float 6s ease-in-out infinite;
        }
      `}</style>

      <style jsx global>{`
        body {
          font-family: 'Cairo', sans-serif;
        }
      `}</style>
    </div>
  );
};

export default AdminLoginPage;